import appStore from "../stores/useAppStore";
import i18n from "../i18n";

export function setError(
  message: string,
  onCloseHandler: (() => void) | null = null,
  title: string = i18n.t("messages.defaultErrorTitle"),
  action: string = i18n.t("messages.defaultErrorAction")
): void {
  appStore.getState().setError({ message, onCloseHandler, title, action });
}

export function resetError(): void {
  appStore.getState().clearError();
}
